module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Box-235f81c0e9d02bc5f8fa0d8e1f781b18.svg";